'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Time;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _msToReadableString = require('../../shared/msToReadableString');

var _msToReadableString2 = _interopRequireDefault(_msToReadableString);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * ProgressBar implementation. Currently displays currentime/duration a wide bar, with
 * differing colours for progressed video and remaining plus a scrubber 'bit' to drag.
 *
 * @providesModule Time
 */

function Time(_ref) {
  var currentTimeMs = _ref.currentTimeMs,
      durationMs = _ref.durationMs,
      playables = _ref.playables;

  var timeLabel = void 0;

  if (playables && playables.size > 0 && durationMs === 0) {
    timeLabel = 'Loading...';
  } else {
    timeLabel = (0, _msToReadableString2.default)(currentTimeMs) + ' / ' + (0, _msToReadableString2.default)(durationMs);
  }

  return _react2.default.createElement(
    'div',
    { className: _style2.default.timeWrapper },
    _react2.default.createElement(
      'div',
      { 'data-qa-id': 'player-time-label' },
      timeLabel
    )
  );
}

Time.propTypes = {
  currentTimeMs: _propTypes2.default.number,
  durationMs: _propTypes2.default.number,
  playables: _propTypes2.default.object
};
module.exports = exports['default'];